// use client: activeTag state drives the year tag filter buttons
'use client'

import type { HomeNewsItem } from '@/types/cms'

import './news.css'

import { newsList as localfull_news } from '@/constants/full_news'

import { useState } from 'react'
import { Col, Row, Stack } from 'react-bootstrap'
import parse from 'html-react-parser'

import alrajhi_logo from '@/assets/images/alrajhi_logo.svg'
import Link from '@/components/Link'

const tagsOf = (items: HomeNewsItem[]) =>
  [...new Set(items.map(item => item.tag))].filter((t): t is string => t != null)

function ListNews({ initialData = null }: { initialData?: HomeNewsItem[] | null }) {
  // Seed from build-time CMS news (+ local constant) so the list and its tag
  // tabs render in the static HTML instead of flickering in after fetch.
  const seeded: HomeNewsItem[] = initialData ? [...initialData, ...localfull_news] : localfull_news
  const seededTags = tagsOf(seeded)
  // Content comes from the build-time snapshot only. A Strapi publish rebuilds
  // and redeploys the site, so there is nothing to revalidate on mount.
  // See tests/no-client-cms-fetch.spec.ts.
  const tags = seededTags
  const newsList = seeded
  const [activeTag, setActiveTag] = useState(seededTags[0] ?? '')

  const stripHtml = html => html.replaceAll(/<[^>]*>/g, '')

  return (
    <div className="container page">
      <h1 className="page-title">Latest News and Announcements</h1>
      {/* todo: button active color */}
      <Stack direction="horizontal" gap={3}>
        {tags.map(item => {
          return (
            <button
              key={item}
              type="button"
              className={activeTag === item ? 'btn-tag active' : 'btn-tag'}
              aria-pressed={activeTag === item}
              onClick={() => setActiveTag(item)}
            >
              {item}
            </button>
          )
        })}
      </Stack>

      <div className="news-section">
        <Row>
          {newsList
            .filter(x => x.tag === activeTag)
            .map(item => {
              const plain = stripHtml(item.description)
              return (
                <Col key={item.slug} md={4}>
                  <div className="news-card d-flex flex-column justify-content-between">
                    <div>
                      <div>
                        <img
                          alt={item.title}
                          src={item.image || alrajhi_logo.src}
                          style={{ objectFit: item.image ? `cover` : `scale-down` }}
                        />
                      </div>
                      <div
                        className="d-flex flex-column justify-content-between content"
                        style={{ height: '180px', overflow: 'hidden', textOverflow: 'ellipsis' }}
                      >
                        <h1>
                          {(item.title ?? '').length < 60
                            ? item.title
                            : (item.title ?? '').slice(0, 60) + '...'}
                        </h1>

                        {!item.isFromCMS && (
                          <p>
                            {(item.description ?? '').length < 60
                              ? parse(item.description ?? '')
                              : parse((item.description ?? '').slice(0, 60)) + '...'}
                          </p>
                        )}

                        {item.isFromCMS && item.description && (
                          <div className="description">
                            {plain.length < 120 ? plain : plain.slice(0, 120) + '...'}
                          </div>
                        )}
                      </div>
                    </div>

                    <div>
                      <div>
                        <div className="d-flex justify-content-between align-items-baseline content">
                          <Link href={`/news/${item.slug}`}>Read More</Link>
                          <p>{item.date}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              )
            })}
        </Row>
      </div>
    </div>
  )
}

export default ListNews
